import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCamera,
  faLock,
  faLocationDot,
  faUserGroup,
  faUserShield
} from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import backgroundImage from '../Images/fundodespedidas.png';
import '../CSS/Despedidas.css';

const DespedidasSolteiro = () => {
  return (
    <div className="er-partyPage">
      <section className="er-partyHero" aria-label="Despedidas de solteiro">
        <img src={backgroundImage} alt="" className="er-partyHeroImg" />
        <div className="er-partyHeroOverlay">
          <div className="er-partyHeroInner">
            <div className="er-partyBadge">Aventura • Risos • Memórias</div>

            <h1 className="er-partyTitle">
              Despedidas
            </h1>
            <h1 className="er-partyTitle">
              <span className="er-partyTitleAccent">de Solteiro(a)</span>
            </h1>

            <p className="er-partyLead">Torna este dia inesquecível!</p>
            <p className="er-partyText">
              Junta o grupo para um último desafio antes do "sim", cheio de adrenalina, mistério e momentos para contar.
              Ideal para celebrar antes do grande dia — com planos adaptados ao vosso estilo.
            </p>

            <div className="er-partyCtas">
              <a
                className="er-partyCtaPrimary"
                href="https://wa.me/351934403133"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faWhatsapp} />
                Falar connosco
              </a>
            </div>
          </div>

          <div className="er-partyHeroCards">
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faUserGroup} className="er-partyHeroCardIcon" />
              <h2 className="er-partyHeroCardTitle">Diversão garantida</h2>
              <p className="er-partyHeroCardText">
                Jogos imersivos pensados para grupo: energia alta desde o primeiro minuto.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faLock} className="er-partyHeroCardIcon" />
              <h2 className="er-partyHeroCardTitle">Desafios épicos</h2>
              <p className="er-partyHeroCardText">
                Enigmas para testar a vossa cooperação e criatividade.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faCamera} className="er-partyHeroCardIcon" />
              <h2 className="er-partyHeroCardTitle">Memórias únicas</h2>
              <p className="er-partyHeroCardText">
                Momentos para recordar e histórias para contar muito mais tarde.
              </p>
            </article>
          </div>

          <div className="er-partyHeroCards">
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faUserGroup} className="er-partyFeatureIcon" />
            <h3 className="er-partyHeroCardTitle">Para todos os grupos</h3>
            <p className="er-partyFeatureText">
              Adaptamo-nos ao tamanho e ao ritmo do vosso grupo.
            </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faLocationDot} className="er-partyFeatureIcon" />
            <h2 className="er-partyHeroCardTitle">Localização top</h2>
            <p className="er-partyFeatureText">
              No coração de Bragança, fácil de chegar e perfeito para continuar a noite.
            </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faUserShield} className="er-partyFeatureIcon" />
            <h3 className="er-partyHeroCardTitle">Equipa dedicada</h3>
            <p className="er-partyFeatureText">
              Apoio antes, durante e depois do jogo para que tudo corra sem stress.
            </p>
            </article>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DespedidasSolteiro;
